<template>
  <mdb-view 
    class="story-view z-depth-1" 
    :style="{ 'background-image' : 'url('+serviceAd.backgroundImage+')',
               'background-attachment' : serviceAd.fixedPositionBackground ? 'fixed' : 'static' }" 
    fluid>
    <mdb-mask overlay="black-strong" />
    <mdb-container class="story-container" >
      <mdb-row>
        <mdb-col 
          col="12" sm="12" md="6" lg="5" xl="4" 
          v-if="serviceAd.rightAligned || isSmallScreen" 
          class="d-flex align-items-center story-image-container">
          <mdb-carousel :interval="3500" class="image-carousel">
            <mdb-carousel-item v-for="(image, index) in serviceAd.images" 
              :key="index" 
              img 
              :src="image.src" 
              :alt="image.alt" 
              class="story-image hoverable mx-auto d-block" 
              :class="{ 'rounded-circle force-circular-border' : serviceAd.circularImage, 
                        'z-depth-2' : serviceAd.imageShadow }" />
          </mdb-carousel>
        </mdb-col>
        <mdb-col col="12" sm="12" md="6" lg="7" xl="8">
          <div class="story-text-container" :class="{ 'story-text-container-right-align' : serviceAd.rightAligned }">
            <h2 class="story-title-text">{{ serviceAd.title }}</h2>
            <p class="story-body-text" v-html="serviceAd.body"></p>
          </div>
        </mdb-col>
        <mdb-col 
          col="12" sm="12" md="6" lg="5" xl="4" 
          v-if="!serviceAd.rightAligned && !isSmallScreen" 
          class="d-flex align-items-center story-image-container">
          <mdb-carousel :interval="3500" class="image-carousel">
            <mdb-carousel-item v-for="(image, index) in serviceAd.images" 
              :key="index" 
              img 
              :src="image.src" 
              :alt="image.alt" 
              class="story-image hoverable mx-auto d-block" 
              :class="{ 'rounded-circle force-circular-border' : serviceAd.circularImage, 
                        'z-depth-2' : serviceAd.imageShadow }" />
          </mdb-carousel>
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col col="12" 
          class="action-button-container"
          :class="{ 'action-button-container-left' : !serviceAd.rightAligned && !isSmallScreen,
                    'action-button-container-right' : serviceAd.rightAligned && !isSmallScreen}">
<!--          <mdb-btn 
            v-if="serviceAd.scrollToContactButton" 
            rounded 
            class="btn-rounded" 
            color="mdb-color" 
            v-scroll-to="formatAnchorLink('Contact')">
            <mdb-icon icon="comments" /> Let's have a talk
          </mdb-btn>
-->
        </mdb-col>
      </mdb-row>
    </mdb-container>
    
  </mdb-view>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbView,
  mdbMask,
  mdbBtn,
  mdbIcon,
  mdbCarousel,
  mdbCarouselItem
} from 'mdbvue'

// serviceAd: {
//title: String,
//body: String,
//backgroundImage: String,
//backgroundVideo: String,
//fixedPositionBackground: Boolean,
//images: Array,
//videos: Array,
//circularImage: Boolean,
//imageShadow: Boolean,
//scrollToContactButton: Boolean,
//rightAligned: Boolean
// }

export default {
  name: 'ServiceAd',
  props: {
    serviceAd: Object
  },
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbView,
    mdbMask,
    mdbBtn,
    mdbIcon,
    mdbCarousel,
    mdbCarouselItem
  },
  data() {
    return {
      window: {
        width: 0
      }
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
    this.handleResize()
  },
  methods: {
    formatAnchorLink(section) {
      return '#' + section;
    },
    handleResize(/*e*/) {
      this.window.width = window.innerWidth;
    } 
  },
  computed: {
    isSmallScreen: function() {
      return (this.window.width < 768 );
    }
  }
}
</script>

<style scoped>
.story-view {
  background-position: top center;
  background-size: cover;
  background-repeat: no-repeat;
}

.story-container {
  padding-top: 75px;
  padding-bottom: 75px;
  text-align: left;
}

.story-text-container {
/*   max-width: 550px; */
}

.story-text-container-right-align {
  text-align: left;
}

.story-title-text {
  font-family: arial, 'sans-serif';
  font-size: 22px;
  color: #DEDEDE;
}

.story-body-text {
  font-family: 'Roboto', arial, 'sans-serif';
  font-family: 12px;
  color: #DEDEDE;
}

.story-reference-text, a:link, a:active, a:visited {
  font-family: 'Roboto', arial, 'sans-serif';
  font-family: 12px;
  font-style: italic;
  color: #DEDEDE;
  text-align: left;
  padding-left: 25px;
}

.story-reference-text a:hover {
  color: white;
}

.story-image-container {
/*   text-align: center; */
}
@media (max-width: 767.98px) {
  .story-image-container {
    padding-bottom: 25px;
  }
}

.image-carousel {
  margin: auto;
}

.story-image {
  width: 300px;
  height: 300px;
}

.action-button-container {
  align-content: center;
  text-align: center;
  align-items: center;
}
.action-button-container-left {
  align-content: left;
  text-align: left;
  align-items: left;
}
.action-button-container-right {
  align-content: right;
  text-align: right;
  align-items: right;
}

/* Fix for missing functionality, in wait of patches. */
.btn-rounded {
  border-radius: 10em;
}

.force-circular-border {
  border-radius: 50% !important;
  .img {
    border-radius: 50% !important;
  }
}

.debug-red {
  border: 1px solid red;
}
.debug-green {
  border: 1px solid green;
}
.debug-blue {
  border: 1px solid blue;
}
.debug-yellow {
  border: 1px solid yellow;
}
</style>